<template lang="pug">
  base-node(:data="data" :nodeType="IQ_TOOL_ACTION_TYPE_RESPONSE")
    template(#icon)
      i.iq-ico-building-kit-response
</template>

<script>
import BaseNode from './BaseNode.vue';
import { IQ_TOOL_ACTION_TYPE_RESPONSE } from '@/constants/iqtool';

export default {
  name: 'DiagramResponseNode',
  components: {
    BaseNode,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      IQ_TOOL_ACTION_TYPE_RESPONSE,
    };
  },
};
</script>

<style scoped>
  .response-node-wrapper {
    border-color: #4AAAB7;
  }
  :deep(.node-title-wrapper) {
    font-size: 8px;
    line-height: 9px;
  }
  .iq-ico-building-kit-response::before {
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_112_393)'%3E%3Cpath d='M0 1.875C0 0.84082 0.84082 0 1.875 0H13.125C14.1592 0 15 0.84082 15 1.875V10.3125C15 11.3467 14.1592 12.1875 13.125 12.1875H9.06152L5.4375 14.9062C5.29688 15.0117 5.10645 15.0293 4.94531 14.9502C4.78418 14.8711 4.6875 14.71 4.6875 14.5312V12.1875H1.875C0.84082 12.1875 0 11.3467 0 10.3125V1.875ZM3.75 7.03125C3.99864 7.03125 4.2371 6.93248 4.41291 6.75666C4.58873 6.58085 4.6875 6.34239 4.6875 6.09375C4.6875 5.84511 4.58873 5.60665 4.41291 5.43084C4.2371 5.25502 3.99864 5.15625 3.75 5.15625C3.50136 5.15625 3.2629 5.25502 3.08709 5.43084C2.91127 5.60665 2.8125 5.84511 2.8125 6.09375C2.8125 6.34239 2.91127 6.58085 3.08709 6.75666C3.2629 6.93248 3.50136 7.03125 3.75 7.03125ZM7.5 7.03125C7.74864 7.03125 7.9871 6.93248 8.16291 6.75666C8.33873 6.58085 8.4375 6.34239 8.4375 6.09375C8.4375 5.84511 8.33873 5.60665 8.16291 5.43084C7.9871 5.25502 7.74864 5.15625 7.5 5.15625C7.25136 5.15625 7.0129 5.25502 6.83709 5.43084C6.66127 5.60665 6.5625 5.84511 6.5625 6.09375C6.5625 6.34239 6.66127 6.58085 6.83709 6.75666C7.0129 6.93248 7.25136 7.03125 7.5 7.03125ZM12.1875 6.09375C12.1875 5.84511 12.0887 5.60665 11.9129 5.43084C11.7371 5.25502 11.4986 5.15625 11.25 5.15625C11.0014 5.15625 10.7629 5.25502 10.5871 5.43084C10.4113 5.60665 10.3125 5.84511 10.3125 6.09375C10.3125 6.34239 10.4113 6.58085 10.5871 6.75666C10.7629 6.93248 11.0014 7.03125 11.25 7.03125C11.4986 7.03125 11.7371 6.93248 11.9129 6.75666C12.0887 6.58085 12.1875 6.34239 12.1875 6.09375Z' fill='%234AAAB7'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_112_393'%3E%3Crect width='15' height='15' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    width: 10px;
    height: 10px;
  }
</style>